import homeStory from "./home";
import officeStory from "./office";
import messagingStory from "./messaging";

export default {
    "home": {
        key: "home",
        name: "Home",
        found: true,
        position: {x:0, y:0, z:0},
        terminalVisible: true,
        story: homeStory,
        connections: [
            "office"
        ]
    },
    "office": {
        key: "office",
        name: "Office",
        found: false,
        position: {x:8, y:0, z:-20},
        terminalVisible: false,
        story: officeStory,
        files: [
            {
                name: "readme.md",
                content: "Please connect to the e-mail server\n" +
                         "This terminal is for internal use only\n\n" +
                         "Sincerely, your IT-staff."
            }
        ]
    },
    "email": {
        key: "email",
        name: "E-mail",
        found: false,
        position: {x:-15, y:0, z:-36},
        terminalVisible: false,
        story: officeStory,
        files: [
            {
                name: "emails.dat",
                font: "courier new",
                content: (function() {
                    var result = "";
                    for(let i = 0; i<256; i++) {
                        let byte = Math.floor(Math.random() * 256).toString(16);
                        byte = byte.length === 1 ? "0" + byte : byte;
                        result += byte + " ";
                        if (i > 0 && (i % 8) == 0) {
                            result += "\n";
                        }
                    }
                    return result;
                }()),
                encrypted: "From: <augusto@exo.com.gov> Augusto Primati\n" +
                           "To: <laura@exo.com.gov> Laura Palmetti\n" +
                           "Date: 2046-10-31 23:45:12 GMT-6\n" +
                           "Subject: Go-ahead for Project Siphon!\n" +
                           "Hi laura,\n" +
                           "Just wanted to let you know we got the go-ahead.\n" +
                           "I know you have your doubts, but we'll swim in money!\n" +
                           "I promise!\n\n" +
                           "Augusto\n\n" +
                           "// Messaging: 345-526-6667\n"
            }
        ]
    },
    messaging: {
        key: "messaging",
        name: "345-526-6667",
        position: {x: -15, y: 5, z: -36},
        color: "#FF0000",
        found: false,
        terminalVisible: false,
        story: messagingStory,
        files: []
    },
    final: {
        key: "final",
        name: "Mainframe",
        position: {x: -20, y: 0, z: -40},
        color: "#FFFF00",
        found: false,
        terminalVisible: false,
        story: [
            {
                lines: [
                    "==========================================",
                    " Exo Oil Mainframe OS v. 233.33.642        ",
                    "==========================================",
                ],
                startAt: 500,
                disableInput: true
            },
            {
                lines: [ "Booting..." ],
                startAt: 1000,
                disableInput: true
            },
            {
                lines: [
                    "...",
                ],
                startAt: 2000,
                disableInput: true
            },
            {
                lines: [
                    "..."
                ],
                startAt: 3000,
                disableInput: true
            },
            {
                lines: ["Thank you for logging in."],
                startAt: 4000
            },
            {
                lines: ["Sadly there's nothing to see here."],
                startAt: 5000
            },
            {
                lines: ["Your creators only had 48 hours to create your world."],
                startAt: 6000
            },
            {
                lines: ["Its future seems very uncertain."],
                startAt: 7000
            },
            {
                lines: ["It could even depend on how people vote!"],
                startAt: 8000
            },
            {
                lines: ["Voting is important..."],
                startAt: 9000
            },
            {
                lines: ["We hope to vote for yours."],
                startAt: 10000
            },
            {
                lines: ["..."],
                startAt: 11000
            },
            {
                lines: ["Super thanks!", "For a super fun Ludum Dare 45!"],
                startAt: 12000
            },
            {
                lines: ["<3"],
                startAt: 13000,
                disableInput: false
            }
        ],
        files: [
            {
                name: "readme.md",
                content: "You've reached the mainframe\nAnd the end of the Ludum Dare episode.\nSorry we couldn't get you more story. o:)\n \n" +
                         "Copyright (c) 2019\nLars-Erik Aabech & Ali Y. Hussein"
            }
        ]
    }
}